import React from "react";
import { Paper, Stack, Typography, Divider } from "@mui/material";
import JourneyCard from "./JourneyCard";

export default function JourneysPanel({
  selectedCampusId,
  selectedCampusLabel,
  filteredJourneys,
  onEditJourney,
  onDeleteJourney,
  onSavePassengers,
  onConfirmJourney,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
      <Stack spacing={1}>
        <Stack spacing={0.5}>
          <Typography fontWeight={800}>
            Journeys {selectedCampusId ? `• ${selectedCampusLabel}` : ""}
          </Typography>

          {selectedCampusId && (
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              {filteredJourneys.length} journey
              {filteredJourneys.length === 1 ? "" : "s"}
            </Typography>
          )}
        </Stack>

        <Divider />

        {!selectedCampusId ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Pick a campus to show journeys.
          </Typography>
        ) : filteredJourneys.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            No journeys for this selection.
          </Typography>
        ) : (
          <Stack spacing={2}>
            {filteredJourneys.map((journey) => (
              <JourneyCard
                key={`journey-${journey.id}`}
                journey={journey}
                onEdit={onEditJourney ? () => onEditJourney(journey) : undefined}
                onDelete={onDeleteJourney}
                onSavePassengers={onSavePassengers}
                onConfirmJourney={onConfirmJourney}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}